import script from "./DreiVergleich.vue?vue&type=script&setup=true&lang=js"
export * from "./DreiVergleich.vue?vue&type=script&setup=true&lang=js"

import "./DreiVergleich.vue?vue&type=style&index=0&id=f4fc6a8a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4fc6a8a"]])

export default __exports__